

import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../styles/Villa.css";
import api from "../apiService/api";

const API_URL = api.API_URL + "read_villas&limit=4&page=1"; // Updated API endpoint for villas
const BASE_URL = api.BASE_URL;



const Villa = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const [page, setPage] = useState(1);

  const [villas, setVillas] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [villasPerPage, setVillasPerPage] = useState(3);
  const [selectedVilla, setSelectedVilla] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Reservation form states
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [name, setName] = useState("");
  const [reservationStatus, setReservationStatus] = useState("idle");
  const [reservationError, setReservationError] = useState(null);

  const [selectedMediaImage, setSelectedMediaImage] = useState({
    index: null,
    image: null,
  });

   const [loadingImages, setLoadingImages] = useState(
      selectedVilla ? new Array(selectedVilla.villa_images.length).fill(true) : []
    );
    
  
    const handleImageLoad = (index) => {
      setLoadingImages((prevLoading) => {
        const newLoading = [...prevLoading];
        newLoading[index] = false; // Mark image as loaded
        return newLoading;
      });
    };

  const handleLightboxNav = (direction) => {
    const totalImages = selectedVilla.villa_images.length;
    let newIndex;

    if (direction === "next") {
      newIndex = (selectedMediaImage.index + 1) % totalImages;
    } else if (direction === "prev") {
      newIndex = (selectedMediaImage.index - 1 + totalImages) % totalImages;
    }

    setSelectedMediaImage({
      index: newIndex,
      image: selectedVilla.villa_images[newIndex].filePath,
    });
  };

  
  useEffect(() => {
    // const fetchVillas = async () => {
    //   try {
       
    //    // Updated endpoint
    //    console.log("test ")
    //    const response = await fetch(`${API_URL}read_villas&limit=4&page=${page}`);
    //     const data = await response.json();

    //     console.log("API Response:", data);

    //     if (data.status === "success" && Array.isArray(data.data)) {
    //       setVillas(
    //         data.data.map((villa) => ({
    //           id: villa.id,
    //           villa_name: villa.villa_name,
    //           location: villa.location,
    //           price: villa.price,
    //           description: villa.description,
    //           coverImage: villa.cover_image || "https://via.placeholder.com/300", // Fallback if null
    //           villa_images: Object.values(villa.villa_images || {}).map((image) => ({
    //             filePath: image.image_path,
    //           })),
    //         }))
    //       );
    //     } else {
    //       setError("Invalid data format");
    //     }
    //   } catch (error) {
    //     console.error("Error fetching villas:", error);
    //     setError("Failed to load villas");
    //   } finally {
    //     setLoading(false);
    //   }
    // };
    const fetchVillas = async () => {
      try {
        // Updated endpoint
        console.log("Fetching page:", page);
        const response = await fetch(`${API_URL}read_villas&limit=4&page=${page}`);
        const data = await response.json();
    
        console.log("API Response:", data);
    
        if (data.status === "success" && Array.isArray(data.data)) {
          setVillas(prevVillas => {
            // For first page, reset the list
            if (page === 1) {
              return data.data.map((villa) => ({
                id: villa.id,
                villa_name: villa.villa_name,
                location: villa.location,
                price: villa.price,
                description: villa.description,
                coverImage: villa.cover_image || "https://via.placeholder.com/300",
                villa_images: Object.values(villa.villa_images || {}).map((image) => ({
                  filePath: image.image_path,
                })),
              }));
            }
            
            // For subsequent pages, append new unique villas
            const newVillas = data.data
              .filter(villa => !prevVillas.some(v => v.id === villa.id))
              .map((villa) => ({
                id: villa.id,
                villa_name: villa.villa_name,
                location: villa.location,
                price: villa.price,
                description: villa.description,
                coverImage: villa.cover_image || "https://via.placeholder.com/300",
                villa_images: Object.values(villa.villa_images || {}).map((image) => ({
                  filePath: image.image_path,
                })),
              }));
            
            return [...prevVillas, ...newVillas];
          });
        } else {
          setError("Invalid data format");
        }
      } catch (error) {
        console.error("Error fetching villas:", error);
        setError("Failed to load villas");
      } finally {
        setLoading(false);
      }
    };
    fetchVillas();
  }, [page]);

 

  // useEffect(() => {
  //   const fetchVillas = async () => {
  //     setLoading(true);
  //     try {
  //       console.log(`Fetching villas for page: ${page}`);
  //       const response = await fetch(`${API_URL}read_villas&limit=${villasPerPage}&page=${page}`);
  //       const data = await response.json();
  
  //       console.log("API Response:", data);
        
  //       // Log the structure of a single villa to debug
  //       if (data.data && data.data.length > 0) {
  //         console.log("First villa structure:", data.data[0]);
  //       }
  
  //       if (data.status === "success" && Array.isArray(data.data)) {
  //         setVillas((prevVillas) => {
  //           if (page === 1) {
  //             // ✅ Reset the list if it's the first fetch
  //             return data.data.map((villa) => {
  //               // Extract villa images correctly
  //               let villaImages = [];
  //               if (villa.images && Array.isArray(villa.images)) {
  //                 villaImages = villa.images.map(img => ({
  //                   filePath: img.image_path || img.path || img || "",
  //                 }));
  //               } else if (villa.villa_images && Array.isArray(villa.villa_images)) {
  //                 villaImages = villa.villa_images.map(img => ({
  //                   filePath: img.image_path || img.path || img || "",
  //                 }));
  //               } else if (villa.media && Array.isArray(villa.media)) {
  //                 // Try 'media' as another possible field
  //                 villaImages = villa.media.map(img => ({
  //                   filePath: img.image_path || img.path || img || "",
  //                 }));
  //               }
                
  //               return {
  //                 id: villa.id,
  //                 villa_name: villa.villa_name,
  //                 location: villa.location,
  //                 price: villa.price,
  //                 description: villa.description,
  //                 coverImage: villa.cover_image || "https://via.placeholder.com/300",
  //                 villa_images: villaImages,
  //               };
  //             });
  //           }
  
  //           // ✅ Otherwise, append new unique villas only
  //           const newVillas = data.data
  //             .filter((villa) => !prevVillas.some((v) => v.id === villa.id))
  //             .map((villa) => {
  //               // Extract villa images correctly (same logic as above)
  //               let villaImages = [];
  //               if (villa.images && Array.isArray(villa.images)) {
  //                 villaImages = villa.images.map(img => ({
  //                   filePath: img.image_path || img.path || img || "",
  //                 }));
  //               } else if (villa.villa_images && Array.isArray(villa.villa_images)) {
  //                 villaImages = villa.villa_images.map(img => ({
  //                   filePath: img.image_path || img.path || img || "",
  //                 }));
  //               } else if (villa.media && Array.isArray(villa.media)) {
  //                 // Try 'media' as another possible field
  //                 villaImages = villa.media.map(img => ({
  //                   filePath: img.image_path || img.path || img || "",
  //                 }));
  //               }
                
  //               return {
  //                 id: villa.id,
  //                 villa_name: villa.villa_name,
  //                 location: villa.location,
  //                 price: villa.price,
  //                 description: villa.description,
  //                 coverImage: villa.cover_image || "https://via.placeholder.com/300",
  //                 villa_images: villaImages,
  //               };
  //             });
  
  //           return [...prevVillas, ...newVillas];
  //         });
  //       } else {
  //         setError("Invalid data format");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching villas:", error);
  //       setError("Failed to load villas");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  
  //   fetchVillas();
  // }, [page]);

   useEffect(() => {
      if (selectedVilla) {
        setLoadingImages(new Array(selectedVilla.villa_images.length).fill(true));
      }
    }, [selectedVilla]);

  // Adjust villas per page based on screen size
  useEffect(() => {
    const updateVillasPerPage = () => {
      const width = window.innerWidth;
      if (width <= 480) {
        setVillasPerPage(1); // Mobile: 1 card
      } else if (width <= 768) {
        setVillasPerPage(1); // Tablet: 1 card for simplicity
      } else if (width <= 1024) {
        setVillasPerPage(2); // Larger tablets: 2 cards
      } else {
        setVillasPerPage(3); // Desktop: 3 cards
      }
    };

    updateVillasPerPage();
    window.addEventListener("resize", updateVillasPerPage);

    return () => window.removeEventListener("resize", updateVillasPerPage);
  }, []);

  // const scrollLeft = () => {
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex === 0 ? villas.length - villasPerPage : prevIndex - 1
  //   );
  // };

  // // const scrollRight = () => {

  // //   setPage((prevPage) => prevPage + 1); 
  // //   setCurrentIndex((prevIndex) =>
  // //     prevIndex >= villas.length - villasPerPage ? 0 : prevIndex + 1
  // //   );
  // // };

  // const scrollRight = () => {
  //   const maxIndex = villas.length - villasPerPage;
  //   if (currentIndex >= maxIndex) {
  //     setPage((prevPage) => prevPage + 1); // ✅ Fetch new page
  //   }
  //   setCurrentIndex((prevIndex) => (prevIndex >= maxIndex ? 0 : prevIndex + 1));
  // };

  // const scrollLeft = () => {
  //   if (currentIndex === 0 && page > 1) {
  //     // Go to previous page when at the beginning
  //     setPage(prevPage => prevPage - 1);
  //   } else {
  //     setCurrentIndex(prevIndex => 
  //       prevIndex === 0 ? Math.max(0, villas.length - villasPerPage) : prevIndex - 1
  //     );
  //   }
  // };
  
  // const scrollRight = () => {
  //   const maxIndex = Math.max(0, villas.length - villasPerPage);
    
  //   // If we're at the end, fetch more data
  //   if (currentIndex >= maxIndex - 1) {
  //     setPage(prevPage => prevPage + 1);
  //   }
    
  //   // Update the index, but don't wrap around to 0 automatically
  //   setCurrentIndex(prevIndex => 
  //     prevIndex >= maxIndex ? prevIndex : prevIndex + 1
  //   );
  // };


  const scrollLeft = () => {
    // If at the first item and there's data
    if (currentIndex === 0 && villas.length > 0) {
      // Go to the last item
      setCurrentIndex(Math.max(0, villas.length - villasPerPage));
    } else {
      // Otherwise just move back one
      setCurrentIndex(prevIndex => Math.max(0, prevIndex - 1));
    }
  };
  
  const scrollRight = () => {
    const maxIndex = Math.max(0, villas.length - villasPerPage);
    
    // If we're approaching the end, fetch more data but don't wait for it
    if (currentIndex >= maxIndex - 1) {
      setPage(prevPage => prevPage + 1);
    }
    
    // If we're at the last position, loop back to the beginning
    if (currentIndex >= maxIndex) {
      setCurrentIndex(0);
    } else {
      // Otherwise, move forward one
      setCurrentIndex(prevIndex => prevIndex + 1);
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setPhoneNumber(value);
  };

  const handleReservationSubmit = async (e) => {
    e.preventDefault();

    if (!selectedVilla) return;

    setReservationStatus("submitting");
    setReservationError(null);

    try {
      const response = await fetch(
        `${BASE_URL}index.php?action=create_villa_reservation`, // Updated endpoint
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            villa_id: selectedVilla.id,
            start_date: startDate,
            end_date: endDate,
            phone_number: phoneNumber,
            name: name,
            status: "pending",
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setReservationStatus("success");
        setStartDate("");
        setEndDate("");
        setPhoneNumber("");
        setName("");
      } else {
        setReservationStatus("error");
        setReservationError(data.message || "Failed to submit reservation");
      }
    } catch (error) {
      setReservationStatus("error");
      setReservationError("Network error. Please try again.");
    }
  };

  // if (loading) return <p>Loading villas...</p>;
  // if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div className="villas-container">
      <div className="Vheader-container">
        <h1 className="villas-title">{t("villasTitle")}</h1> {/* Updated title */}
        <div className="navigation-buttons">
          <button className="Vnav-btn" onClick={isArabic ? scrollRight : scrollLeft}>
            {isArabic ? "→" : "←"}
          </button>
          <button className="Vnav-btn" onClick={isArabic ? scrollLeft : scrollRight}>
            {isArabic ? "←" : "→"}
          </button>
        </div>
      </div>

      <div className="villas-grid">
        {villas.slice(currentIndex, currentIndex + villasPerPage).map((villa) => (
          <div key={villa.id} className="villa-card">
            <div className="Vimage-container">
              <img src={villa.coverImage} alt={villa.villa_name} className="villa-image" />
              <div className="Vimage-overlay" />
            </div>
            <div className="villa-info">
              <div className="text-content">
                <h3 className="villa-title">{villa.villa_name}</h3>
                <p className="villa-location"><strong>{villa.location}</strong></p>
                <p className="villa-price">{villa.price} MAD</p>
                <p className="villa-description">{villa.description}</p>
              </div>
              <button className="learn-more-btn" onClick={() => setSelectedVilla(villa)}>
                <span className="nav">{isArabic ? "←" : "→"}</span>
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedVilla && (
        <div className="modal-overlay" onClick={() => setSelectedVilla(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedVilla(null)}>×</button>
            <img src={selectedVilla.coverImage} alt={selectedVilla.villa_name} className="modal-image" />
            <h2 className="modal-title">{selectedVilla.villa_name}</h2>
            <p className="modal-location">
              <strong>{t("locationLabel")}</strong> {selectedVilla.location}
            </p>
            <p className="modal-price">
              <strong>{t("priceLabel")}</strong> {selectedVilla.price} MAD
            </p>
            <p className="modal-description">{selectedVilla.description}</p>

            {selectedVilla.villa_images.length > 0 && (
              <div className="media-gallery">
                {selectedVilla.villa_images.map((image, index) => (
              //     <img
              //       key={index}
              //       src={image.filePath}
              //       alt="Villa media"
              //       className="media-image"
              //       onClick={() => setSelectedMediaImage({ index, image: image.filePath })}
              //     />
              //   ))}
              // </div>
              <div key={index} className="media-container">
              {/* Shimmer effect */}
              {loadingImages[index] && <div className="shimmer"></div>}

              {/* Image with onLoad event */}
              <img
                src={image.filePath}
                alt="Villa media"
                className={`media-image ${loadingImages[index] ? "hidden" : ""}`}
                onLoad={() => handleImageLoad(index)}
                onClick={() => setSelectedMediaImage({ index, image: image.filePath })}
              />
            </div>
          ))}
        </div>
            )}

            {selectedMediaImage.index !== null && (
              <div
                className="lightbox-overlay"
                onClick={() => setSelectedMediaImage({ index: null, image: null })}
              >
                <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                  <button
                    className="lightbox-Vnav-btn left"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLightboxNav("prev");
                    }}
                  >
                    ←
                  </button>
                  <img src={selectedMediaImage.image} alt="Enlarged media" className="lightbox-image" />
                  <button
                    className="lightbox-Vnav-btn right"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLightboxNav("next");
                    }}
                  >
                    →
                  </button>
                  <button
                    className="close-btn"
                    onClick={() => setSelectedMediaImage({ index: null, image: null })}
                  >
                    ×
                  </button>
                </div>
              </div>
            )}

            <div className="vreservation-section">
              <h3>{t("reservationFormTitle", "Make a Reservation")}</h3>
              {reservationStatus === "success" ? (
                <div className="vreservation-success">
                  <p>{t("reservationSuccessMessage", "Your reservation request has been submitted successfully!")}</p>
                  <button
                    className="form-buttonV"
                    onClick={() => setReservationStatus("idle")}
                    style={{ marginTop: "20px", width: "auto", padding: "0 20px" }}
                  >
                    {t("makeAnotherReservation", "Make Another Reservation")}
                  </button>
                </div>
              ) : (
                <form onSubmit={handleReservationSubmit} className="vreservation-form">
                  <div className="date-inputs">
                    <div className="date-field">
                      <label htmlFor="start-date">{t("checkIn", "Check-In")}</label>
                      <input
                        id="start-date"
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="form-dateV"
                        required
                      />
                    </div>
                    <div className="date-field">
                      <label htmlFor="end-date">{t("checkOut", "Check-Out")}</label>
                      <input
                        id="end-date"
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="form-dateV"
                        required
                      />
                    </div>
                  </div>
                  <div className="phone-field">
                    <label htmlFor="phone-number">{t("phoneNumber", "Phone Number")}</label>
                    <input
                      id="phone-number"
                      type="tel"
                      value={phoneNumber}
                      onChange={handlePhoneChange}
                      className="form-phoneV"
                      placeholder={t("phonePlaceholder", "Enter your phone number")}
                      required
                    />
                  </div>
                  <div className="phone-field">
                    <label htmlFor="name">{t("name", "Name")}</label>
                    <input
                      id="name"
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="form-phoneV"
                      placeholder={t("namePlaceholder", "Enter your name")}
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="form-buttonV"
                    disabled={reservationStatus === "submitting"}
                  >
                    {reservationStatus === "submitting"
                      ? t("submitting", "Submitting...")
                      : t("submitReservation", "Submit Reservation")}
                  </button>
                  {reservationStatus === "error" && (
                    <p className="vreservation-error">{reservationError}</p>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Villa;


